// extracted by mini-css-extract-plugin
export default {"center":"onboarding-explanations_center__fkvi+","text":"onboarding-explanations_text__af5QF"};